// src/main.js
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 导入背景设置全局样式
import '@/assets/styles/background-global.css'

// 预加载背景图片
import { preloadBackgroundImages, migrateOldSettings } from '@/utils/storage'

Vue.config.productionTip = false

Vue.use(ElementUI)

// 迁移旧设置
migrateOldSettings()

// 预加载背景图片
setTimeout(() => {
  preloadBackgroundImages()
}, 1000)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
